module.exports = __webpack_public_path__ + "static/marketingImg-4eb1e5308cfddfa8ac6fb50abdbde40f.svg";